import { NullableTranslationMap, SupportedLanguage } from '../types';
import { ProvinceResponse } from '../stores/business-unit';
import { getProvinceNameTags } from './provinces_tag';
import { Tag } from '../components/tag';

export const getGamesLocaleItem = (
    items: NullableTranslationMap,
    lang: SupportedLanguage
) => {
    return items[lang];
};

export function RegionTag({ provinces }: { provinces: string[] }) {
    const provincesNames = getProvinceNameTags(provinces);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '0.25rem',
                flexWrap: 'wrap',
            }}
        >
            {provincesNames?.map((r) => (
                <Tag variant="greek-blue" key={r}>
                    {r}
                </Tag>
            ))}
        </div>
    );
}

export function GameRegionTag({ region }: { region: ProvinceResponse[] }) {
    return (
        <RegionTag
            provinces={(region || []).map(({ province }) => province.name)}
        />
    );
}
